import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
//getters
import application from "@/store/getters/application";

//modules
import achievements from "@/store/modules/achievements";
import agenda from "@/store/modules/agenda";
import agendaEvent from "@/store/modules/agendaEvent";
import capgeminiCompanies from "@/store/modules/capgeminiCompanies";
import clients from "@/store/modules/clients";
import client from "@/store/modules/client";
import comments from "@/store/modules/comments";
import customSection from "@/store/modules/customSection";
import engagements from "@/store/modules/engagements";
import files from "@/store/modules/files";
import highlightContent from "@/store/modules/highlightContent";
import hireRequest from "@/store/modules/hireRequest";
import hireRequests from "@/store/modules/hireRequests";
import idea from "@/store/modules/idea";
import ideas from "@/store/modules/ideas";
import images from "@/store/modules/images";
import initiatives from "@/store/modules/initiatives";
import leaderboard from "@/store/modules/leaderboard";
import leaderboards from "@/store/modules/leaderboards";
import news from "@/store/modules/news";
import newsSingle from "@/store/modules/newsSingle";
import project from "@/store/modules/project";
import projects from "@/store/modules/projects";
import publicCompanies from "@/store/modules/publicCompanies";
import quiz from "@/store/modules/quiz";
import quizzes from "@/store/modules/quizzes";
import solution from "@/store/modules/solution";
import teamMembers from "@/store/modules/teamMembers";
import user from './modules/user'
import userInfo from "@/store/modules/userInfo";


Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

let localStorage = createPersistedState({
    // paths: ['user.token', 'user.isLoggedIn', 'user.userCompanies', 'user.selectedCompanyId', 'user.selectedCompanyName'],
    // Only persist essential authentication data
})

export default new Vuex.Store({
    // actions,
    getters: application,
    modules: {
        achievements,
        agenda,
        agendaEvent,
        capgeminiCompanies,
        client,
        clients,
        comments,
        customSection,
        engagements,
        files,
        idea,
        ideas,
        images,
        initiatives,
        highlightContent,
        hireRequest,
        hireRequests,
        leaderboard,
        leaderboards,
        news,
        newsSingle,
        project,
        projects,
        publicCompanies,
        quiz,
        quizzes,
        solution,
        user,
        userInfo,
        teamMembers,
    },
    strict: debug,
    plugins: [localStorage]
})
